import axios from 'axios'
import HTTP from './http'

export default {
    updateUserPolicies: payload => axios.put(HTTP.POLICY_PARSER_USER_CASES, payload)
}
